import ApiService from '@/services/api.service';

const DrugOrdersInboxService = {
    getAll(parameter) {
        const params = {
            SearchCriteria: parameter.SearchCriteria,
            PageSize: parameter.PageSize,
            PageNumber: parameter.PageNumber,
            DateFrom: parameter.DateFrom,
            DateTo: parameter.DateTo,
            Status: parameter.Status,
            PrescriberCodeList: parameter.PrescriberCodeList,
            FacilityCodeList: parameter.FacilityCodeList,
            PatientCodeList: parameter.PatientCodeList,
            IsInpatient: parameter.IsInpatient,
            UsageIsInpatient: parameter.UsageIsInpatient,
            BranchLocationCode: parameter.BranchLocation,
            ProgramsRestriction: parameter.ProgramsRestriction
        };
        return ApiService.getWithArray('/DrugOrdersInbox/', params);
    },

    UpdateStatus(data) {
        return ApiService.put(`/DrugOrdersInbox/UpdateStatus`, data);
    },

    UpdateFormularyStatus(data) {
        return ApiService.put(`/DrugOrdersInbox/UpdateFormularyStatus`, data);
    },

    UpdateStatusValidate(data) {
        return ApiService.put(`/DrugOrdersInbox/UpdateStatusValidate`, data);
    },

    UpdateStatusUndoValidate(data) {
        return ApiService.put(`/DrugOrdersInbox/UpdateStatusUndoValidate`, data);
    },

    CanFillOrder(IsMars, RecordId) {
        return ApiService.get(
            `/DrugOrdersInbox/CanFillOrder?IsMars=${IsMars}&RecordID=${RecordId}`
        );
    },
    CanValidOrder(IsMars, RecordId) {
        return ApiService.get(
            `/DrugOrdersInbox/CanValidOrder?IsMars=${IsMars}&RecordID=${RecordId}`
        );
    },

    CanReturnedItemOrder(IsMars, RecordId) {
        return ApiService.get(
            `/DrugOrdersInbox/CanReturnedItemOrder?IsMars=${IsMars}&RecordID=${RecordId}`
        );
    },

    getOrderHeader(DrugCode, RecordId, Location) {
        return ApiService.get(
            `/DrugOrdersInbox/GetOrderHeader?DrugCode=${DrugCode}&RecordID=${RecordId}&Location=${Location}`
        );
    },

    getOrderHeaderMars(RecordId, DrugCode, Location) {
        return ApiService.get(
            `/DrugOrdersInbox/GetOrderHeader?DrugCode=${DrugCode}&RecordID=${RecordId}&Location=${Location}&MARS=Y`
        );
    },
    getOrderDetailsMars(RecordId, DrugCode, Location, QtySet) {
        return ApiService.get(
            `/DrugOrdersInbox/GetOrderSPDetails?DrugCode=${DrugCode}&RecordID=${RecordId}&ToFill=${QtySet}&Location=${Location}&MARS=Y`
        );
    },

    getOrderDetails(DrugCode, RecordId, Location, qtyToFill) {
        return ApiService.get(
            `/DrugOrdersInbox/GetOrderDetails?DrugCode=${DrugCode}&RecordID=${RecordId}&ToFill=${qtyToFill}&Location=${Location}`
        );
    },

    getLocations(params = null) {
        return ApiService.getWithArray(`/DrugOrdersInbox/GetPharmacyLocations`, params || '');
    },

    FillOrder(data) {
        return ApiService.post(`/DrugOrdersInbox/FillOrders`, data);
    },

    getInventoryItemInfo(code) {
        return ApiService.get(`/DrugOrdersInbox/Info/${code}`);
    },

    getReturnedItems(parameters) {
        const requestData = {
            method: 'get',
            url: '/DrugOrdersInbox/ReturnItems',
            params: parameters
        };
        return ApiService.customRequest(requestData);
    },

    setReturnedItems(data) {
        return ApiService.put(`/DrugOrdersInbox/ReturnItems`, data);
    },

    undoOrders(data) {
        return ApiService.put(`/DrugOrdersInbox/UndoOrders`, data);
    },

    UpdateChargeable(data) {
        return ApiService.put(`/DrugOrdersInbox/UpdateChargeable`, data);
    }
};

export default DrugOrdersInboxService;
